import {Component, OnInit} from '@angular/core';
import {FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PaylinkSubscription} from '../../models/paylink-subscription';
import {GlobalLoaderService} from '../../services/global-loader.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {ApiAgentService} from '../../services/api-agent.service';
import {ActivatedRoute, Router, RouterModule} from '@angular/router';
import {MyBusiness} from '../../models/my-business';
import {ChangeMerchantPackageRequest} from '../../models/change-merchant-package-request';
import {MerchantPaylinkPaymentResponse} from '../../models/merchant-paylink-payment-response';
import {PackagePanelComponent, PaymentVia} from '../settings/package-panel/package-panel.component';
import {firstValueFrom} from 'rxjs';
import {EventBusService} from '../../services/event-bus.service';
import {CommonModule} from '@angular/common';

declare var Snackbar: any;
declare var $: any;

@Component({
  selector: 'app-confirm-choosing-package',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule, PackagePanelComponent],
  templateUrl: './confirm-choosing-package.component.html',
  styleUrls: ['./confirm-choosing-package.component.scss']
})
export class ConfirmChoosingPackageComponent implements OnInit {

  msg: any;
  loading: any;
  form: FormGroup;
  lang: any;
  submitted: boolean;
  myBusiness: MyBusiness;
  submitting: boolean;
  subscriptionsList: PaylinkSubscription[];
  selectedSubscription: PaylinkSubscription;
  couponCode: any;

  constructor(private loader: GlobalLoaderService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private translate: TranslateService,
              private eventBus: EventBusService,
              private api: ApiAgentService) {
  }

  // @ts-ignore
  get f() {
    return this.form.controls;
  }

  // @ts-ignore
  get v() {
    return this.form.value;
  }

  async ngOnInit() {
    this.loading = true;
    this.submitting = false;
    let subscriptionId = this.activatedRoute.snapshot.paramMap.get('subscriptionId');
    this.couponCode = this.activatedRoute.snapshot.paramMap.get('couponCode');

    this.subscriptionsList = await this.api.getPaylinkSubscriptions();
    this.myBusiness = await this.api.getMyBusiness(true);

    this.selectedSubscription = null;

    for (let pak of this.subscriptionsList) {
      if (pak.id == subscriptionId) {
        this.selectedSubscription = pak;
      }
    }

    if (this.selectedSubscription == null && this.couponCode != null) {
      this.subscriptionsList = await this.api.validateCouponCode(this.couponCode);
      for (let pak of this.subscriptionsList) {
        if (pak.id == subscriptionId) {
          this.selectedSubscription = pak;
        }
      }
    }

    if (this.selectedSubscription) {
      if (this.selectedSubscription.subscriptionType == 'package') {
        this.msg = await this.translate.get('Are you sure want to subscribe to the following subscription, you cannot change this later:').toPromise();
      } else if (this.selectedSubscription.subscriptionType == 'marketing') {
        // this.msg = await this.translate.get('The remaining period of time in your current package, if it is with a monthly or annual subscription, will be kept until the end of the marketing package.').toPromise();
        this.msg = await this.translate.get('الباقة التسويقية لن تلغي الباقة الحالية. اذا لديك مدة زمنية متبقية في باقتك الحالية سيتم الاحتفاظ بها لك إلى حين انتهاء الباقة التسويقية').toPromise();
      }
    }

    setTimeout(async () => {
      await this.loadResources();
      this.lang = await this.translate.get('lang').toPromise();
      this.loading = false;
    }, 1000);
  }

  private async loadResources() {
    await this.loader.loadExternalStyles('/plugins/notification/snackbar/snackbar.min.css');
    console.log('');
    await this.loader.loadExternalScript('/plugins/notification/snackbar/snackbar.min.js');
    await this.loader.loadExternalStyles('/plugins/dropify/dropify.min.css');
    await this.loader.loadExternalStyles('/assets/css/users/account-setting.css');
    await this.loader.loadExternalScript('/plugins/dropify/dropify.min.js');
    await this.loader.loadExternalScript('/plugins/blockui/jquery.blockUI.min.js');
    console.log('');
    await this.loader.loadExternalScript('/assets/js/users/account-settings.js');

    $('.dropify').dropify({
      messages: {
        'default': await this.translate.get('Click to Upload or Drag n Drop').toPromise(),
        'remove': '<i class="flaticon-close-fill"></i>',
        'replace': await this.translate.get('Upload or Drag n Drop').toPromise()
      }
    });
  }

  showToast(msg) {
    Snackbar.show({
      text: msg,
      pos: 'bottom-center'
    });
  }

  data: ChangeMerchantPackageRequest;

  async reloadPage() {
    location.reload();
  }

  async paymentSubmittedAgain() {
    if (await this.sendPaymentToServer(this.data)) { // if payment sent to server, show popup and redirect.
      $('#minusPlanOkModal').modal('show');
    }
  }

  async paymentSubmitted(data: ChangeMerchantPackageRequest) {
    this.submitting = true;
    if (this.myBusiness && this.myBusiness.walletAmount < data.amount && data.paymentVia != PaymentVia.BankCard
      && (this.selectedSubscription.yearlyFees > 0
        || this.selectedSubscription.monthlyFees > 0
        || this.selectedSubscription.setupFees > 0)
    ) {
      this.data = data;
      $('#proceedModal').modal('show');
    } else {
      if (await this.sendPaymentToServer(data)) { // if payment sent to server, show toast and redirect
        this.eventBus.emitRefreshMyBusiness();
        this.showToast(await firstValueFrom(this.translate.get('My package changed successfully')));
        setTimeout(async () => {
          await this.router.navigateByUrl('/private/settings');
        }, 3000);
      }
    }
  }

  private async sendPaymentToServer(data: ChangeMerchantPackageRequest) {
    try {
      let result: MerchantPaylinkPaymentResponse = await this.api.postMerchantPackageChange(
        data.subscriptionId,
        data.paymentPlan,
        data.paymentVia,
        (data.amount),
        this.couponCode
      );
      if (result.paymentUrl) {
        await this.showToast(await this.translate.get('You will be redirected to payment page').toPromise());
        setTimeout(async () => {
          window.location.href = result.paymentUrl;
        }, 3000);
      } else {
        return true;
      }
    } catch (e) {
      if (e.error.title) {
        this.showToast(await this.translate.get(e.error.title).toPromise());
      } else {
        this.showToast(await this.translate.get('Could not change my package. Try again').toPromise());
      }
      this.submitting = false;
      this.submitted = false;
    }
  }

  async continueAfterPayment() {
    await this.router.navigateByUrl('/private/settings');
  }
}
